import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    flex: 1,
    width: '100%',
    height: '420px',
    overflow: 'auto',
    boxShadow: 'none',
    paddingRight: theme.spacing(2),
    '-ms-overflow-style': 'none',

    '&::-webkit-scrollbar': {
      width: '3px',
    },

    // /* Hide scrollbar for IE and Edge */
    // .example {
    //   -ms-overflow-style: none;
    // }'
  },
}));